import {

	// CreateItem Component
	CreateItemIconsf1,
	CreateItemIconsf2,
	CreateItemIconsf3,
	CreateItemIconsf4,
	CreateItemIconsf5,
	CreateItemIconsf6,
	CreateItemIconsf7,


} from '../../utils/allImgs'


export const CreateItemDataImg = [
	{
		img:CreateItemIconsf1,
		text:'Art',
	},
	{
		img:CreateItemIconsf2,
		text:'Virtual Worlds',
	},
	{
		img:CreateItemIconsf3,
		text:'Purchases',
	},
	{
		img:CreateItemIconsf4,
		text:'NFT Gifts',
	},
	{
		img:CreateItemIconsf5,
		text:'Collectibles',
	},
	{
		img:CreateItemIconsf6,
		text:'Gifts',
	},
	{
		img:CreateItemIconsf7,
		text:'Trading Cards',
	},
]

export const CreateItemDataInput = [
	{
		name:'Price',
		title:'Item Price in ETH',
		fullWidth:false,
		hafWidth:false
	},
	{
		name:'Royalties',
		title:'Royalties',
		fullWidth:false,
		hafWidth:true
	},
	{
		name:'Size',
		title:'Size',
		fullWidth:false,
		hafWidth:true
	},
	{
		name:'copies',
		title:'Number of copies',
		fullWidth:true,
		hafWidth:false
	},
]

// export {data1 , data2 , data3}